import { render, staticRenderFns } from "./MainNavbar.vue?vue&type=template&id=bbac296e&scoped=true"
import script from "./MainNavbar.vue?vue&type=script&lang=js"
export * from "./MainNavbar.vue?vue&type=script&lang=js"
import style0 from "./MainNavbar.vue?vue&type=style&index=0&id=bbac296e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbac296e",
  null
  
)

export default component.exports